module.exports = __webpack_public_path__ + "img/chevron-down.399fc230.svg";